import MatchLoads from './MatchLoads'
import MatchTrucks from './MatchTrucks'

const MatchView = ({ loadToMatch, truckToMatch }) => (
  <div className="tennders-brokers-trucks-match-load-info mt-10">
    {loadToMatch && <MatchLoads /> }
    {truckToMatch && <MatchTrucks />}
  </div>
)
export default MatchView
